<div class="tool-content-container">
  <div class="tool-description">
    Select a
    <instruction-step-link link="cohort" text="Cohort" />, a Category (College,
    Department, <instruction-step-link link="program" text="Program)" />, a
    Direction (Forward
    <i
      class="fa-solid fa-circle-info tooltipIcon"
      matTooltip="Forward: The flow out of student to different colleges, departments, or programs from selected college, department or program"
      matTooltipPosition="right"
    ></i
    >, Backward
    <i
      class="fa-solid fa-circle-info tooltipIcon"
      matTooltip="Backward: The flow in of students who graduated into the selected college, department or program"
      matTooltipPosition="right"
    ></i
    >), an Entry/Exit, the range for High School GPA [Default: 0-5]
    <i
      class="fa-solid fa-circle-info tooltipIcon"
      matTooltip="Default gives all possible values."
      matTooltipPosition="right"
    ></i
    >, a Year Range
    <i
      class="fa-solid fa-circle-info tooltipIcon"
      matTooltip="Gives the flow in or flow out for the selected range."
      matTooltipPosition="right"
    ></i
    >, and click submit to generate results for entry or exit flow graph.
    <!-- 

    <b class="instructions-title"
      >To generate results for entry or exit flow graph:</b
    ><br />
    Step 1 <i class="fa-solid fa-arrow-right"></i> Select a
    <instruction-step-link link="cohort" text="Cohort" />
    <br />
    Step 2 <i class="fa-solid fa-arrow-right"></i> Select a Category (College,
    Department, <instruction-step-link link="program" text="Program)" />
    <br />
    Step 3 <i class="fa-solid fa-arrow-right"></i> Select a Direction (Forward
    <i
      class="fa-solid fa-circle-info tooltipIcon"
      matTooltip="Forward: The flow out of student to different colleges, departments, or programs from selected college, department or program"
      matTooltipPosition="right"
    ></i
    >, Backward
    <i
      class="fa-solid fa-circle-info tooltipIcon"
      matTooltip="Backward: The flow in of students who graduated into the selected college, department or program"
      matTooltipPosition="right"
    ></i
    >) <br />
    Step 4 <i class="fa-solid fa-arrow-right"></i> Select an Entry/Exit (Based
    on the category chosen on step 2)<br />
    Step 5 <i class="fa-solid fa-arrow-right"></i> Select the range for High
    School GPA [Default: 0-5]
    <i
      class="fa-solid fa-circle-info tooltipIcon"
      matTooltip="Default gives all possible values."
      matTooltipPosition="right"
    ></i
    ><br />
    Step 6 <i class="fa-solid fa-arrow-right"></i> Select a Year Range
    <i
      class="fa-solid fa-circle-info tooltipIcon"
      matTooltip="Gives the flow in or flow out for the selected range."
      matTooltipPosition="right"
    ></i>
    <br />
    Step 7 <i class="fa-solid fa-arrow-right"></i> Click on the submit button -->

    <br /><br />

    <b class="important-note">*Hover on the links to view more info.</b>
  </div>

  <div class="chart-title-with-btn-icon">
    <button
      matTooltip="Save chart as image"
      mat-icon-button
      aria-label="Chart snap icon"
      (click)="dataService.exportAmChartsAsPNG(root, 'entry-exit-chart')"
    >
      <mat-icon>photo_camera</mat-icon>
    </button>
  </div>
  <div id="chartdiv"></div>

  <back-button></back-button>
</div>
